/**
 * Ryan O'Dowd
 * 2022-04-13
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = () => {
  return {
    templateContainerStyles: {
      flex: 1,
      flexGrow: 1,
      padding: 0,
      width: '100%',
    },
    notesContainer: {
      flexShrink: 1,
      justifyContent: 'center',
      width: '100%',
    },
    list: {
      width: '100%',
    },
  };
};

export default getStyles;
